export default __webpack_public_path__ + "58020c103ba20e38a274982c73f34a58.svg";